/**
 * FairPlay Key System.
 *
 * @group DRM
 *
 * @beta
 */
export const FAIRPLAY_KEY_SYSTEM = 'com.apple.fps.1_0';
//# sourceMappingURL=FAIRPLAY_KEY_SYSTEM.js.map